import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-message-list-item',
  templateUrl: './message-list-item.component.html',
  styleUrls: ['./message-list-item.component.css']
})
export class MessageListItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
